import { ReactNode } from "react"
import TextInput from "Components/molecule/inputs/text-input"
import FormContainer from "Components/atoms/containers/form-container"
import PrimaryButton from "Components/atoms/buttons/primary-button"
import FormProps from "data/forms"
import CreateUserFields from "./types"

const EMAIL_KEY = 'email'
const PASSWORD_KEY = 'password'

interface CreateUserFormProps extends FormProps<CreateUserFields> {
    // Shown under the email input (employee match status)
    emailStatus?: ReactNode
}

const CreateUserForm = ({
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    errors,
    isValid,
    touched,
    isSubmitting,
    emailStatus
}: CreateUserFormProps) => {
    return <FormContainer
        inputs={<>
            <TextInput
                touched={!!touched.email}
                name={EMAIL_KEY}
                key={EMAIL_KEY}
                label={"Email*"}
                placeholder={"Enter an email"}
                type="email"
                value={values.email}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!errors.email && touched.email}
                message={touched.email ? errors.email : undefined}
            />
            {emailStatus && <div className="mb-3">{emailStatus}</div>}
            <TextInput
                touched={!!touched.password}
                name={PASSWORD_KEY}
                key={PASSWORD_KEY}
                label={"Password*"}
                placeholder={"Enter a password"}
                type="password"
                value={values.password}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!errors.password && touched.password}
                message={touched.password ? errors.password : undefined}
            />
        </>}
        buttons={
            <PrimaryButton
                type='submit'
                onClick={() => handleSubmit()}
                disabled={isSubmitting || !isValid}
                className="w-100"
            >
                {isSubmitting ? "Creating...." : "Create User"}
            </PrimaryButton>
        }
    />
}

export default CreateUserForm
